"use client";

import useSWR from "swr";
import { ImageAPI, ImageScoreExistsRequest } from "@/restapi/image";


const useImageScoreExists = (request: ImageScoreExistsRequest) => {
  // Session hydration 前の空文字列 userUuid での API 呼び出しを防止
  // userUuid が存在するまで fetcher をスキップ
  const shouldFetch = !!request.userUuid;
  const swrKey = shouldFetch ? `image-score-exists-${JSON.stringify(request)}` : null;

  const { data, error, isLoading, mutate } = useSWR(
    swrKey,
    () => ImageAPI.scoreExists(request),
    {
      refreshInterval: 2000,
      revalidateOnFocus: true,      // ウィンドウアクティブ時に再検証
      revalidateOnReconnect: true,  // ネットワーク再接続時に再検証
      dedupingInterval: 500,        // 重複排除期間を短縮（デフォルト2000ms）
    }
  );

  return {
    data,
    isLoading,
    isError: error,
  };
};

export { useImageScoreExists };
